"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackOfferModel = void 0;
const packOffer_json_1 = __importDefault(require("../constants/packOffer.json"));
class PackOfferModel {
    constructor(packOfferName) {
        Object.assign(this, packOffer_json_1.default[packOfferName]);
        this.name = packOfferName;
    }
}
exports.PackOfferModel = PackOfferModel;
//# sourceMappingURL=PackOfferModel.js.map